module.exports = __webpack_public_path__ + "static/media/ldapsearch.5b534647.svg";